import React from "react";
import PropTypes from "prop-types";
import { EmptyState } from "@opendate-app/setlist";

const EmptyFamily = ({ family }) => (
  <EmptyState size="sm" icon={family.icon} title="No segments yet" description={family.blurb} />
);

EmptyFamily.propTypes = {
  family: PropTypes.shape({
    icon: PropTypes.elementType,
    blurb: PropTypes.string,
  }).isRequired,
};

export default EmptyFamily;
